import AbstractTrackingAdapter, { Revenue } from './AbstractTrackingAdapter';

export default class AggregatorTrackingAdapter extends AbstractTrackingAdapter {
  trackingHandlers: AbstractTrackingAdapter[];

  constructor(trackingHandlers) {
    super();
    this.trackingHandlers = trackingHandlers;
  }

  logEvent = (eventName: string, eventProperties: any) => {
    this.trackingHandlers.map(trackingHandler =>
      trackingHandler.logEvent(eventName, eventProperties)
    );
  };

  revenue = (revenue: Revenue) => {
    this.trackingHandlers.map(trackingHandler => trackingHandler.revenue(revenue));
  };

  setUser = user => {
    this.trackingHandlers.map(trackingHandler => trackingHandler.setUser(user));
  };
}
